import axios from "axios";
import router from "@/router";
import qs from "qs";
axios.defaults.timeout = 10000; //设置10秒请求超时时间
// axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers["Content-Type"] = "application/json";

/*定义请求头*/
// axios.defaults.headers.appId = 1;
// axios.defaults.headers.appVersionId = 1;
// axios.defaults.headers.companyNo = 1000;

/*定义请求地址*/
// const base = "http://192.168.5.230:9001/api/v1"; //测试环境
const base = "https://hw.pan-go.com/api/v1"; //生产环境
axios.defaults.baseURL = base;
// axios.defaults.baseURL = "/api";
export const baseURL = base;

let load = null;
// 请求拦截器
axios.interceptors.request.use(
    (config) => {
        // 每次发送请求之前判断vuex中是否存在token
        // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断

        const token = sessionStorage.getItem("token");
        token && (config.headers.Authorization = token);
        load = layer.load();
        return config;
    },
    (error) => {
        return Promise.error(error);
    }
);

// 响应拦截器
axios.interceptors.response.use(
    (response) => {
        layer.close(load);
        // 状态码为200，接口请求成功，可以拿到数据
        if (response.status === 200) {
            if (response.data.errCode === 0) return Promise.resolve(response);
            else {
                return Promise.resolve(response);
            }
        } else if (response.status == 401) {
            console.log(response);
            layer.msg("登录失效，请重新登录!");
            setTimeout(function() {
                router.push({ name: "login" });
            }, 1000);
            return Promise.resolve(response);
        } else {
            return Promise.resolve(response);
        }
    },
    (error) => {
        layer.close(load);
        // console.log(error.toString());
        // console.log(JSON.stringify(error));
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    // 返回 401 清除token信息并跳转到登录页面
                    layer.msg("登录失效，请重新登录!");
                    setTimeout(function() {
                        router.push({ name: "login" });
                    }, 1000);
            }
        }
        return Promise.reject(error);
    }
);
let request = {
    get: "",
    post: "",
};
request.get = function(url, data, options) {
    //参数的序列化
    // let params = qs.stringify(data);
    return new Promise((resolve, reject) => {
        // axios.get(url+'?'+params).then((res)=>{
        //     resolve(res);
        // })
        if (url.indexOf("getVcode") != -1) {
            axios
                .get(url, {
                    params: data,
                    responseType: "arraybuffer",
                })
                .then((res) => {
                    resolve(res);
                });
        } else {
            axios({
                method: "get",
                url: url,
                params: data,
                ...options,
            })
                .then((res) => {
                    resolve(res);
                })
                .catch((e) => {
                    reject(e);
                });
        }
    });
};
request.post = function(url, data, options) {
    return new Promise((resolve, reject) => {
        axios
            .post(url, data, options)
            .then((res) => {
                resolve(res);
            })
            .catch((e) => {
                reject(e);
            });
    });
};
export default request;
